'use strict';

import * as d3 from 'd3';
import { tip as d3tip } from 'd3-v6-tip';

export function addTooltip ($gWrapper, $bars, tipShowCb, hoverClassName) {
  const tip = d3tip().attr('class', 'barD3Tip d3-tip').html((EVENT, d) => d);
  let isLock = false;
  let $lockTarget = null;
  function hideTooltip ($this) {
    $this.classed(hoverClassName, false);
    $this.style('filter', '');
    tip.hide();
  }

  const timestemp = new Date().getTime();
  const filterId = `dropShadow_${this.barOrientation}_${timestemp}`;
  const defs = $gWrapper.append('defs');
  const filter = defs.append('filter')
    .attr('id', filterId);
  filter.append('feDropShadow')
    .attr('dx', 2)
    .attr('dy', 5)
    .attr('stdDeviation', 1)
    .attr('flood-opacity', 0.15);

  $bars
    .on('click', function () {
      if (!isLock) {
        isLock = true;
        $lockTarget = d3.select(this);
      } else {
        isLock = false;
        tip.hide();
        const $this = d3.select(this);
        $this.dispatch('mouseover');
      }
    })
    .on('mouseover', function (event, d) {
      if (isLock) { return; }
      const $this = d3.select(this);
      $this.classed(hoverClassName, true);
      if (hoverClassName !== 'line-hover') {
        $this.style('filter', `url(#${filterId})`);
      }
      tip.show(event, tipShowCb.bind(this, event, d));
    })
    .on('mousemove', (event) => {
      if (isLock) { return; }
      if (this.tooltipAtMousePosition) {
        const x = event.screenX;
        const y = event.screenY;
        const tipElement = d3.selectAll('.barD3Tip');

        const currentWidth = tipElement.style('width').replace('px', '');
        const currentHeight = tipElement.style('height').replace('px', '');
        // console.log('mousemove', event);
        tipElement
          .style('top', ((event.pageY - Number(currentHeight) - 10) + 'px'))
          .style('left', (event.pageX - (Number(currentWidth) / 2)) + 'px');
      }
    })
    .on('mouseout', function (event) {
      if (isLock) { return; }
      hideTooltip(d3.select(this));
    })
    .call(tip);

  const rectOverlay = $gWrapper
    .insert('rect', ':first-child')
    .attr('class', 'rect-overlay')
    .attr('width', '100%')
    .attr('height', '100%');
  rectOverlay.on('click', function (event) {
    if (!isLock) { return; }
    isLock = false;
    hideTooltip($lockTarget);
  });

  return tip;
}

export function getValueListTemplate (values, decimalPoint, colors) {
  let value = '<ul class="tooltip-ul">';
  for (const key of Object.keys(values)) {
    let tempVal;
    if (values[key]) {
      tempVal = values[key].toFixed(decimalPoint);
    } else if (values[key] === 0) {
      tempVal = 0;
    } else {
      tempVal = 'N/A';
    }
    const bubbleColor = colors && colors[key] ? colors[key] : '#bbb';
    value += `<li><div class="tooltip-box-container">
    <div class="tooltip-text-label">
      <span class="tooltip-bubble" style="background-color:${bubbleColor};"></span>${key}: 
    </div>
    <div class="tooltip-text-space"></div>
    <div class="tooltip-text-value">${tempVal}</div>
    </div></li>`;
  }
  value += '<ul>';

  return value;
}
